"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RequestMethod = {
  GET: 'GET',
  POST: 'POST'
};
var _default = exports.default = RequestMethod;